import { withI18n } from '@lingui/react'
import { shape, string } from 'prop-types'

import { i18nType } from 'views/utils/propTypes'
import setInnerHTML from 'views/utils/setInnerHTML'

/**
 * Component allows to translate strings with HTML content.
 * All the passed props will be spreaded into `element` as is
 * except listed ones.
 *
 * @param {Object} args
 * @param {String} args.id Translation string id
 * @param {Object} args.i18n
 * @param {Object} [args.values] Values to be passed into translation string
 * @param {React.ReactNode} args.element Element in which a translated string to be inserted
 * @param {String} args.className
 */
const TransWithHtml = ({ id, i18n, values, element, className }) => {
  const Component = element

  return (
    <Component {...setInnerHTML(i18n._(id, values))} className={className} />
  )
}

TransWithHtml.propTypes = {
  id: string.isRequired,
  i18n: i18nType.isRequired,
  values: shape({}),
  element: string,
  className: string,
}

TransWithHtml.defaultProps = {
  className: null,
  element: 'span',
}

export default withI18n()(TransWithHtml)
